import { fg } from '@atlaskit/platform-feature-flags';

export function trackChangesPluginOptions(): { showOnToolbar?: boolean } {
	return {
		showOnToolbar: fg('platform_editor_toolbar_aifc_undo_redo_confluence'),
	};
}
